export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
} as const

export const ERROR_CODE = { NETWORK: 'ERR_NETWORK' } as const
